import React, { useState, useEffect, useLayoutEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import FloatingWhatsApp from './components/FloatingWhatsApp';
import Home from './pages/Home';
import Agency from './pages/Agency';
import Projects from './pages/Projects';
import ProjectDetail from './pages/ProjectDetail';
import Missions from './pages/Missions';
import Contact from './pages/Contact';
import News from './pages/News';
import CityPage from './pages/CityPage';
import ArticlePage from './pages/ArticlePage';
import { translations } from './translations';
import LegalNotice from './pages/LegalNotice';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Faq from './pages/Faq';
import NotFound from "./pages/NotFound";
import { heraultCities } from './data/heraultCities';

// Scroll en haut à chaque changement de route (avant le paint, sans hack de timers)
function ScrollToTop() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    const html = document.documentElement;
    const previousBehavior = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';
    window.scrollTo(0, 0);
    html.style.scrollBehavior = previousBehavior;
  }, [pathname]);

  return null;
}

function App() {
  const [language, setLanguage] = useState('fr');
  const t = translations[language];

  // Maintient l'attribut lang du document synchro avec la langue choisie (a11y/SEO)
  useEffect(() => {
    document.documentElement.lang = language;
  }, [language]);

  return (
    <Router basename="/">
      <ScrollToTop />
      <div className="app">
        <a href="#main-content" className="skip-link">Aller au contenu principal</a>
        <Header language={language} setLanguage={setLanguage} t={t} />

        <main id="main-content" style={{ paddingTop: '80px', minHeight: '90vh' }}>
          <Routes>
            <Route path="/" element={<Home t={t} language={language} />} />
            <Route path="/agency" element={<Agency t={t} language={language} />} />
            <Route path="/projects" element={<Projects t={t} language={language} />} />
            <Route path="/project/:id" element={<ProjectDetail t={t} language={language} />} />
            <Route path="/missions" element={<Missions t={t} language={language} />} />
            <Route path="/contact" element={<Contact t={t} language={language} />} />
            <Route path="/news" element={<News t={t} language={language} />} />
            <Route path="/legal-notice" element={<LegalNotice t={t} />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy t={t} />} />
            <Route path="/faq" element={<Faq language={language} />} />

            {/* Pages Villes Hérault SEO — générées depuis les données (1 ville = 1 entrée dans heraultCities.js) */}
            {heraultCities.map((city) => (
              <Route
                key={city.slug}
                path={`/architecte-${city.slug}`}
                element={<CityPage city={city} t={t} language={language} />}
              />
            ))}

            {/* Articles Actualités */}
            <Route path="/actualites/:slug" element={<ArticlePage t={t} language={language} />} />

            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>

        <Footer t={t} />
        <FloatingWhatsApp language={language} />
      </div>
    </Router>
  );
}

export default App;
